export default __webpack_public_path__ + "static/media/neander.cc9cb92a.jpg";